import { FROM_URL_REDIRECT_KEY, REDIRECT_URL_KEY, UNAUTHENTICATED_REDIRECT_URL } from '../constants/routingConstants'

/**
 * Removes and returns the page a member was on before being sent to a gate (e.g. the require eligibility form),
 * marked with `fromUrlRedirect` like LW's `addFromUrlRedirectParam`. Returns null when nothing was saved or the saved
 * page is on another origin. Returns an absolute URL because a path like `//evil.com` would leave the site.
 */
export const takeUnauthenticatedRedirectUrl = () => {
  const savedUrl = window.sessionStorage.getItem(UNAUTHENTICATED_REDIRECT_URL)
  if (!savedUrl) return null
  window.sessionStorage.removeItem(UNAUTHENTICATED_REDIRECT_URL)
  const url = new URL(savedUrl, window.location.origin)
  if (url.origin !== window.location.origin) return null
  url.searchParams.set(FROM_URL_REDIRECT_KEY, 'true')
  return url.href
}

/** Clear both auth return addresses when they match the destination being consumed. */
export const clearStoredAuthRedirects = (destination: string | null) => {
  if (!destination) return
  const storage = window.sessionStorage
  if (storage.getItem(REDIRECT_URL_KEY) === JSON.stringify(destination)) {
    storage.removeItem(REDIRECT_URL_KEY)
  }
  if (storage.getItem(UNAUTHENTICATED_REDIRECT_URL) === destination) {
    storage.removeItem(UNAUTHENTICATED_REDIRECT_URL)
  }
}

export const routeToCustomerLoginUrl = (customer: string, queryParams?: Record<string, string>) => {
  const currentCustomer = extractCustomerFromUrl()
  let redirectUrl = window.location.origin.replace(`${currentCustomer}.`, `${customer}.`) + '/login'
  if (queryParams) {
    const searchParams = new URLSearchParams(queryParams)
    redirectUrl += `?${searchParams.toString()}`
  }
  window.location.replace(redirectUrl)
}

const extractCustomerFromUrl = () => {
  const { host } = window.location
  return host.substring(0, host.indexOf('.'))
}
